import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Container, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  chgActualiteFilter,
  chgEmissionFilter,
  chgPodcastFilter,
  chgIdeeFilter,
  chgPublicationFilter,
  selectInViewsFilters,
} from "../../../redux/ReduxFilter";

const BlocFiltreInViews = (props) => {
  const { t } = useTranslation();
  const { ReduxInstance } = props;
  const dispatch = useDispatch();
  const _selectInViewFilters = useSelector(selectInViewsFilters);
  const scrollContainerRef = useRef(null);
  const checkedCheckboxRef = useRef(null);

  useEffect(() => {
    if (checkedCheckboxRef.current && scrollContainerRef.current) {
      // Obtenir la position de la checkbox cochée
      const checkboxRect = checkedCheckboxRef.current.getBoundingClientRect();

      // Obtenir la largeur de la fenêtre (ou du conteneur parent)
      const containerRect = scrollContainerRef.current.getBoundingClientRect();

      // Calculer la position de défilement pour centrer l'élément
      const scrollLeftPosition =
        checkboxRect.left - containerRect.left - containerRect.width / 2 + checkboxRect.width / 2;

      // Déplacer la scrollbar
      scrollContainerRef.current.scrollTo({
        left: scrollLeftPosition,
        behavior: "smooth", // pour un effet de défilement fluide
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="sliderSticky">
      <div className="enteteBlocFiltre">
        <span>{t("public.filtres.filtre22")}</span>
      </div>
      <Container
        fluid
        className="mb-3 d-flex align-items-center flex-nowrap containerFiltres"
        ref={scrollContainerRef}
      >
        <div className="m-1  align-items-center d-flex">
          <Form.Check
            className={_selectInViewFilters.idee ? "filtreActif" : "filtreNonActif"}
            type="checkbox"
            label={t("public.filtres.filtre10")}
            id="idee"
            name="idee"
            onChange={(e) => dispatch(chgIdeeFilter(!_selectInViewFilters.idee))}
            checked={_selectInViewFilters.idee ? "checked" : ""}
          />
        </div>
        {ReduxInstance.modulesActives.includes("actualite") && (
          <div className="m-1  align-items-center d-flex">
            <Form.Check
              className={_selectInViewFilters.actualite ? "filtreActif" : "filtreNonActif"}
              type="checkbox"
              label={t("public.filtres.filtre11")}
              id="actualite"
              name="actualite"
              onChange={(e) => dispatch(chgActualiteFilter(!_selectInViewFilters.actualite))}
              checked={_selectInViewFilters.actualite ? "checked" : ""}
            />
          </div>
        )}
        {ReduxInstance.modulesActives.includes("emission") && (
          <>
            <div className="m-1  align-items-center d-flex" ref={checkedCheckboxRef}>
              <Form.Check
                className={_selectInViewFilters.emission ? "filtreActif" : "filtreNonActif"}
                type="checkbox"
                label={t("public.filtres.filtre12")}
                id="emission"
                name="emission"
                onChange={(e) => dispatch(chgEmissionFilter(!_selectInViewFilters.emission))}
                checked={_selectInViewFilters.emission ? "checked" : ""}
              />
            </div>
            <div className="m-1  align-items-center d-flex">
              <Form.Check
                className={_selectInViewFilters.podcast ? "filtreActif" : "filtreNonActif"}
                type="checkbox"
                label={t("public.filtres.filtre13")}
                id="podcast"
                name="podcast"
                onChange={(e) => dispatch(chgPodcastFilter(!_selectInViewFilters.podcast))}
                checked={_selectInViewFilters.podcast ? "checked" : ""}
              />
            </div>
          </>
        )}
        {ReduxInstance.modulesActives.includes("publication") && (
          <div className="m-1  align-items-center d-flex">
            <Form.Check
              className={_selectInViewFilters.publication ? "filtreActif" : "filtreNonActif"}
              type="checkbox"
              label={t("public.filtres.filtre14")}
              id="publication"
              name="publication"
              onChange={(e) => dispatch(chgPublicationFilter(!_selectInViewFilters.publication))}
              checked={_selectInViewFilters.publication ? "checked" : ""}
            />
          </div>
        )}
      </Container>
    </div>
  );
};

export default BlocFiltreInViews;
